import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// Meta Pixel Code
;
(function (f: any, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Element) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode!.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', '1251837510200280');
(window as any).fbq('track', 'PageView');
render(<App data-id="element-596" />, document.getElementById('root'));